/* oxlint-disable react/forbid-elements */

export const FilePreviewImage = () => {
  return (
    <svg width="100" height="124" viewBox="0 0 100 124" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d)">
        <rect x="16" y="8" width="68" height="92" rx="4" fill="var(--theme-white)" />
        <rect x="16.5" y="8.5" width="67" height="91" rx="3.5" stroke="var(--theme-dark)" strokeOpacity="0.1" />
      </g>
      <rect x="38" y="16" width="24" height="4" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="24" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="90" width="22" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="34" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="38" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="42" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="46" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="50" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <rect x="24" y="54" width="52" height="2" fill="var(--theme-dark)" fillOpacity="0.1" />
      <circle cx="66" cy="82" r="10" fill="var(--theme-dark)" fillOpacity="0.06" />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="100"
          height="124"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
